import ControlProps from '../../../mixins/ControlProps';
import { RadioPropertyType } from '../enums';
import { StyleOrientationType } from '@/ui-kit/styles/enums';

const RadioProps = {
  props: {
    ...ControlProps.props,
    [RadioPropertyType.Options]: {
      type: Array,
      default: () => [],
    },
    [RadioPropertyType.Orientation]: {
      type: String,
      default: StyleOrientationType.Vertical,
    },
  },
};

export default RadioProps;
